/* eslint-disable react-hooks/exhaustive-deps */
import { createStyles, FormControl, FormControlLabel, IconButton, makeStyles, Radio, RadioGroup, Theme } from '@material-ui/core';
import React, { useEffect, useState } from 'react';
import { ChartCommonProps, IconButtonWrapper } from '../Common';
import { ChartFilter } from '../ChartComponents';
import CloseIcon from '@material-ui/icons/Close';
import { convertStringNumberToNumber, formatNumber, formatToDatePeriod, getLabels, getMaxTickLimit, getSuggestedMaxTick } from '../../helpers/ChartHelper';
import { SelectedItemProps } from '../MattersByStatusChart';
import gql from 'graphql-tag';
import { useQuery } from 'react-apollo';
import { DrillDownType } from '../DrillDownType';
import { SearchCriteria } from '../SearchCriteria';
import { Bar, getElementAtEvent } from 'react-chartjs-2';
import { Chart as ChartJS, CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, Scale, Tick, Chart, ChartEvent, ActiveElement } from 'chart.js';
import zoomPlugin from 'chartjs-plugin-zoom';
import { useScreenshot, createFileName } from 'use-react-screenshot';
import AspectRatioIcon from '@material-ui/icons/AspectRatio';
import GetAppOutlinedIcon from '@material-ui/icons/GetAppOutlined';
import KeyboardArrowUpIcon from '@material-ui/icons/KeyboardArrowUp';
import KeyboardArrowDownIcon from '@material-ui/icons/KeyboardArrowDown';
import MTooltip from '@material-ui/core/Tooltip';
import { ChartInfo } from '../../components/ChartInfo';

import { RV_CHART_CLASS, RV_CHART_COLORS, isChartDataEmpty, rvBarDatasetStyle, rvChartAnimation, rvCategoryAxisStyle, rvTooltipStyle, rvValueAxisStyle } from '../chartTheme';
import { ChartHeading } from '../ChartHeading';
import { AnimatedNumber } from '../AnimatedNumber';
import { ChartSkeleton } from '../../components/loading/ChartSkeleton';
import { ChartEmptyState } from '../ChartEmptyState';
import AccessTimeOutlinedIcon from '@material-ui/icons/AccessTimeOutlined';
ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend, zoomPlugin);

const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        root: {
            position: 'relative',
            paddingBottom: '10px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            maxWidth: '100%',
            maxHeight: '100%',
            height: '100%',
            textAlign: 'center',
            '@media print': {
                display: 'flex',
                flexFlow: 'column',
                alignItems: 'center',
                boxShadow: 'none !important',
            },
        },
        popover: {},
        paper: {},
        radioGroup: {
            flexFlow: 'row wrap',
            justifyContent: 'center',
        },
        closeIcon: {
            color: 'rgb(0, 120, 212)',
        },
        titleContainer: {
            display: 'flex',
            flexFlow: 'column',
            padding: '20px 15px',
            '& .title': {
                fontSize: 16,
            },
            '& .colWrapper': {
                display: 'flex',
                justifyContent: 'center',
                alignItems: 'center',
                marginTop: 15,
                flexFlow: 'row wrap',
            },
            '& .col': {
                fontSize: '16px',
                fontWeight: 600,
                textAlign: 'center',
                border: '1px solid',
                padding: '15px',
                display: 'flex',
                margin: '0 10px 10px 10px',
                flexFlow: 'column',
                flex: 1,
                '& .value': {
                    fontSize: '36px',
                    padding: '20px 0',
                },
                '& .sub': {
                    display: 'flex',
                    flexFlow: 'row wrap',
                    justifyContent: 'center',
                    alignItems: 'center',
                },
                '& .status': {
                    marginLeft: '10px',
                    display: 'flex',
                    flexFlow: 'row wrap',
                    alignItems: 'center',
                },
            },
            '& .increase': {
                color: 'green',
            },
            '& .decrease': {
                color: 'red',
            },
        },
        barContainer: {
            padding: '5px 15px 15px 15px',
            minHeight: '300px',
            flex: 1,
            display: 'flex',
            flexFlow: 'column',
            justifyContent: 'center',
            alignItems: 'center',
            maxHeight: '350px',
            maxWidth: 'auto',
            position: 'relative',
            '@media (max-width: 533px)': {
                maxWidth: '350px',
                margin: '0 auto',
            },
            '& .titleWrapper': {
                textAlign: 'center',
                display: 'inline-block',
                width: '100%',
                padding: '15px',
                '& .title': {
                    fontSize: '18px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .value': {
                    fontSize: '24px',
                    fontWeight: 600,
                    display: 'block',
                    marginBottom: '15px',
                },
                '& .secondary-title': {
                    fontSize: '16px',
                    fontWeight: 400,
                    display: 'block',
                    marginBottom: '15px',
                },
            },
        },
        loadingWrapper: {
            padding: '20px',
            display: 'flex',
            justifyContent: 'center',
            alignItems: 'center',
            height: '100%',
            position: 'relative'
        },
        title: {
            fontSize: 16,
            fontWeight: 600,
            fontFamily: 'inherit',
            marginBottom: 0,
        },
        totalDiv: {
            cursor: 'pointer',
            paddingRight: 5,
        },
        total: {
            fontSize: '2.5rem',
            padding: '10px 0',
            fontWeight: 600,
            cursor: 'pointer',
        },
        span: {
            fontSize: '1rem',
        },
        helpIcon: {
            position: 'absolute',
            left: '5px',
            top: '5px',
            '@media print': {
                display: 'none !important',
            },
        },
        scrollUp: {
            position: 'absolute',
            top: '30px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        },
        scrollDown: {
            position: 'absolute',
            bottom: '90px',
            justifyContent: 'center',
            transform: 'translateX(-50%)',
            left: '50%',
            minWidth: '54px',
        }
    }),
);
enum PeriodSelectionEnum {
    THIS_MONTH = 0,
    PREVIOUS_MONTH,
    THIS_YEAR,
    PREVIOUS_YEAR,
}
interface NonBillatimesByActivityChartProps extends SelectedItemProps, ChartCommonProps {
    chartFilter?: ChartFilter;
    selectedOption?: PeriodSelectionEnum;
}
interface NonBillableTimesByActivityData {
    statistics: Statistics;
}
export interface Statistics {
    time: Time;
}
export interface Time {
    nonBillableTimesByActivity: NonBillableTimes;
}
export interface NonBillableTimes {
    thisMonth: NonBillableTimesGrouping;
    previousMonth: NonBillableTimesGrouping;
    thisYear: NonBillableTimesGrouping;
    previousYear: NonBillableTimesGrouping;
}
export interface NonBillableTimesGrouping {
    summary: NonBillableTimeSummary;
    financialYearToPreviousMonth: NonBillableTimeSummary;
    times: NonBillableTime[];
}
export interface NonBillableTime {
    hours: number;
    timelines: number;
    grouping: string;
    format: string;
}
export interface NonBillableTimeSummary {
    lastPeriodTotal: number;
    previousPeriodTotal: number;
}
interface ChartState {
    option: PeriodSelectionEnum;
    hours: number[];
    timelines: number[];
    grouping: string[];
    format: string[];
    currentYearTotal: number;
    currentTotal: number;
    leftPeriodString: string;
    rightPeriodString: string;
    symbol: string;
}
export const NonBillableTimesByActivityChart: React.FC<NonBillatimesByActivityChartProps> = (props) => {
    const classes = useStyles();

    // tslint:disable-next-line:no-any
    const chartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const entireChartRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const scrollUpAndPrevRef = React.useRef<any>();

    // tslint:disable-next-line:no-any
    const scrollDownAndNextRef = React.useRef<any>();

    const { loading, error, data } = useQuery<NonBillableTimesByActivityData>(NON_BILLABLE_TIMES_BY_ACTIVITY_QUERY, {
        variables: {
            entityType: props.chartFilter?.entityType,
            entityGuid: props.chartFilter?.entityGuid,
            responsibility: props.chartFilter?.responsibility,
            showAllRecords: props.showAllRecords
        },
    });

    const takeScreenShot = useScreenshot({
        type: 'image/jpeg',
        quality: 1.0
    })[1];

    const [state, setState] = useState<ChartState>({
        option: props.selectedOption === undefined ? PeriodSelectionEnum.THIS_MONTH : props.selectedOption,
        hours: [],
        timelines: [],
        grouping: [],
        format: [],
        currentYearTotal: 0,
        currentTotal: 0,
        leftPeriodString: formatToDatePeriod('monthToDate'),
        rightPeriodString: formatToDatePeriod('yearToDate'),
        symbol: '$',
    });

    const currencySymbolQuery = useQuery<CurrencySymbolData>(CURRENCY_SYMBOL_QUERY);

    useEffect(() => {
        if (currencySymbolQuery.data && currencySymbolQuery.data.options && !currencySymbolQuery.loading && !currencySymbolQuery.error) {
            setState((prevState) => {
                return {
                    ...prevState,
                    symbol: currencySymbolQuery.data!.options.currencySymbol.symbol,
                };
            });
        }
        // tslint:disable-next-line: align
    }, [currencySymbolQuery.loading, currencySymbolQuery.error, currencySymbolQuery.data]);

    useEffect(() => {
        window.addEventListener('keydown', onKeyDownHandler);

        return () => {
            window.removeEventListener('keydown', onKeyDownHandler);
        };
        // tslint:disable-next-line: align
    }, []);

    // tslint:disable-next-line: no-any
    const onKeyDownHandler = (event: any) => {
        if (event.keyCode === 80 && (event.ctrlKey || event.metaKey) && !event.altKey) {
            event.preventDefault();
            if (event.stopImmediatePropagation) {
                event.stopImmediatePropagation();
            } else {
                event.stopPropagation();
            }
            return;
        }
    };

    useEffect(() => {
        if (!loading) {
            setState((prevState) => {
                let hours: number[] = [];
                let timelines: number[] = [];
                let grouping: string[] = [];
                let format: string[] = [];
                let currentTotal: number = 0;
                let currentYearTotal: number = 0;
                let leftPeriodString: string = '';
                let rightPeriodString: string = formatToDatePeriod('yearToDate');
                if (!error && data && data.statistics && data.statistics.time && data.statistics.time.nonBillableTimesByActivity) {
                    var thisMonth = data.statistics.time.nonBillableTimesByActivity.thisMonth;
                    var previousMonth = data.statistics.time.nonBillableTimesByActivity.previousMonth;
                    var thisYear = data.statistics.time.nonBillableTimesByActivity.thisYear;
                    var previousYear = data.statistics.time.nonBillableTimesByActivity.previousYear;
                    currentYearTotal = thisYear.summary.lastPeriodTotal;
                    if (state.option === PeriodSelectionEnum.THIS_MONTH) {
                        hours = thisMonth.times.map((s) => s.hours);
                        timelines = thisMonth.times.map((s) => s.timelines);
                        grouping = thisMonth.times.map((s) => s.grouping);
                        format = thisMonth.times.map((s) => s.format);
                        currentTotal = thisMonth.summary.lastPeriodTotal;
                        leftPeriodString = formatToDatePeriod('monthToDate');
                    } else if (state.option === PeriodSelectionEnum.THIS_YEAR) {
                        hours = thisYear.times.map((s) => s.hours);
                        timelines = thisYear.times.map((s) => s.timelines);
                        grouping = thisYear.times.map((s) => s.grouping);
                        format = thisYear.times.map((s) => s.format);
                        currentTotal = thisYear.summary.lastPeriodTotal;
                        leftPeriodString = formatToDatePeriod('yearToDate');
                    } else if (state.option === PeriodSelectionEnum.PREVIOUS_MONTH) {
                        hours = previousMonth.times.map((s) => s.hours);
                        timelines = previousMonth.times.map((s) => s.timelines);
                        grouping = previousMonth.times.map((s) => s.grouping);
                        format = previousMonth.times.map((s) => s.format);
                        currentTotal = previousMonth.summary.lastPeriodTotal;
                        leftPeriodString = formatToDatePeriod('monthToDate');
                        rightPeriodString = formatToDatePeriod('previousMonthYearToDate');
                        if (previousMonth.financialYearToPreviousMonth) {
                            currentYearTotal = previousMonth.financialYearToPreviousMonth.lastPeriodTotal;
                        } else {
                            currentYearTotal = 0;
                        }
                    } else {
                        hours = previousYear.times.map((s) => s.hours);
                        timelines = previousYear.times.map((s) => s.timelines);
                        grouping = previousYear.times.map((s) => s.grouping);
                        format = previousYear.times.map((s) => s.format);
                        currentTotal = previousYear.summary.lastPeriodTotal;
                        leftPeriodString = formatToDatePeriod('previousYearToDate');
                    }
                }
                return {
                    ...prevState,
                    hours,
                    timelines,
                    grouping,
                    format,
                    currentTotal,
                    currentYearTotal,
                    leftPeriodString,
                    rightPeriodString,
                };
            });
        }
        // tslint:disable-next-line: align
    }, [state.option, loading, error, data]);

    const onCloseChart = () => {
        if (props.onCloseChart) {
            props.onCloseChart('isNonBillableTimesByActivityChartOpen');
        }
    };

    const onMaximize = () => {
        if (props.onMaximize) {
            props.onMaximize(state.option);
        }
    };

    const onScrollUpAndPrev = (type: 'up' | 'prev') => {
        if (chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min > 0) {
            const scrollRatio = chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max - chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min;
            const min = chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min;
            if (scrollRatio < chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min) {
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min -= scrollRatio ? scrollRatio : 1;
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max -= scrollRatio ? scrollRatio : 1; 
            } else {
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].min -= min;
                chartRef.current.options.scales[type === 'up' ? 'y' : 'x'].max -= min;
            }
            chartRef.current.options.scales[type === 'up' ? 'x' : 'y'].min = 0;
            chartRef.current.update();
            // enabled scroll up
            scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
        } else {
            // disabled scroll up
            scrollUpAndPrevRef.current.classList.add('Mui-disabled');
        }
        scrollDownAndNextRef.current.classList.remove('Mui-disabled');
    };
    
    const onScrollDownAndNext = (type: 'down' | 'next') => {

        const labels = state.hours;

        if (chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max < labels.length) {
            const remainingBar = labels.length - chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max;
            const scrollRatio = chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max - chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min;
            if (remainingBar <= scrollRatio) {
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min += remainingBar;
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max += remainingBar;
            } else {
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].min += scrollRatio ? scrollRatio : 1;
                chartRef.current.options.scales[type === 'down' ? 'y' : 'x'].max += scrollRatio ? scrollRatio : 1;
            }
            chartRef.current.options.scales[type === 'down' ? 'x' : 'y'].min = 0;
            chartRef.current.update();
            // enabled scroll down
            scrollDownAndNextRef.current.classList.remove('Mui-disabled');
        } else {
            // disabled scroll down
            scrollDownAndNextRef.current.classList.add('Mui-disabled');
        }
        scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
    };

    const onScollBar = (type: 'up' | 'down' | 'prev' | 'next') => () => {
        if (type === 'up') {
            onScrollUpAndPrev('up');
        } else if (type === 'down') {
            onScrollDownAndNext('down');
        }  else if (type === 'next') {
            onScrollDownAndNext('next');
        } else {
            onScrollUpAndPrev('prev');
        } 
    };

    const onDisabledEnabledArrow = (barType: 'horizontal' | 'vertical') => {  
        const labels = state.hours;
        // up 
        if (chartRef.current.options.scales[barType === 'horizontal' ? 'y' : 'x'].min > 0) {
            scrollUpAndPrevRef.current.classList.remove('Mui-disabled');
        } else {
            scrollUpAndPrevRef.current.classList.add('Mui-disabled');
        }

        // down
        if (chartRef.current.options.scales[barType === 'horizontal' ? 'y' : 'x'].max < labels.length) {
            scrollDownAndNextRef.current.classList.remove('Mui-disabled');
        } else {
            scrollDownAndNextRef.current.classList.add('Mui-disabled');
        }
    };

    const onPan = (context: { chart: Chart }) => {

        onDisabledEnabledArrow('horizontal');

        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    const onHover = (event: ChartEvent, elements: ActiveElement[], chart: Chart) => {
        (event?.native?.target as HTMLElement).style.cursor = elements.length > 0 ? 'pointer' : 'auto';
    };
    
    const onZoom = (context: { chart: Chart }) => {

        onDisabledEnabledArrow('horizontal');

        chartRef.current.options.scales.x.min = 0;
        chartRef.current.update();
    };

    // tslint:disable-next-line: no-any
    const onContextMenu = (event: any) => {
        event.preventDefault();
        if (event.button !== 2) {
            return false;
        }
        return true;
    };

    // tslint:disable-next-line: no-any
    const onDownload = (name: string, extension: string = 'jpg') => (image: any) => {
        const a = document.createElement('a');
        a.href = image;
        a.download = createFileName(extension, name);
        a.click();
    };

    const onDownloadScreenshot = () => {
        setTimeout(() => {
            takeScreenShot(entireChartRef.current).then(onDownload('Non-billable Times by Activity'));
        // tslint:disable-next-line: align
        }, 500);
    };

    const chartControllerComponent = () => {
        return (
            <>
                <IconButtonWrapper aria-label="close">
                    <ChartInfo 
                        description={props.description}
                        fontSize={props.showAllRecords ? 'large' : 'medium'}
                        className={`${classes.helpIcon} rv-chart-help`}
                    />
                    {props.showAllRecords && (
                        <IconButton size="medium" onClick={onDownloadScreenshot}>
                            <GetAppOutlinedIcon color="primary" fontSize="large" />
                        </IconButton>
                    )}
                    {!props.showAllRecords && props.onMaximize && (
                        <MTooltip title="Expand chart">
                            <IconButton aria-label="maximize" onClick={onMaximize} size="small">
                                <AspectRatioIcon />
                            </IconButton>
                        </MTooltip>
                    )}
                    <IconButton aria-label="close" onClick={onCloseChart} size={props.showAllRecords ? 'medium' : 'small'}>
                        <CloseIcon className={classes.closeIcon} fontSize={props.showAllRecords ? 'large' : 'medium'} />
                    </IconButton>
                </IconButtonWrapper>
            </>
        );
    };

    const onChangeRadio = (event: React.ChangeEvent<HTMLInputElement>) => {
        setState((prevState) => {
            return {
                ...prevState,
                // tslint:disable-next-line: radix
                option: parseInt((event.target as HTMLInputElement).value),
            };
        });
    };
    const getPeriodSelectionLabel = (period: PeriodSelectionEnum) => {
        switch (period) {
            case PeriodSelectionEnum.THIS_MONTH:
                return 'This Month';
            case PeriodSelectionEnum.PREVIOUS_MONTH:
                return 'Previous Month';
            case PeriodSelectionEnum.THIS_YEAR:
                return 'Financial Year';
            default:
                return 'Previous Financial Year';
        }
    };
    const handleTotalClick = (isFinancialYear: boolean) => {
        if (props.getSelectedItem) {
            const criteria = new Array<SearchCriteria>();
            var label = '';
            criteria.push({ property: 'Amount', operator: 'eq', comparison: '0' });
            if (!isFinancialYear) {
                switch (state.option) {
                    case PeriodSelectionEnum.THIS_YEAR:
                        criteria.push({ property: 'FinancialYear', operator: '', comparison: 'curr' });
                        break;
                    case PeriodSelectionEnum.PREVIOUS_YEAR:
                        criteria.push({ property: 'FinancialYear', operator: '', comparison: 'prev' });
                        break;
                    case PeriodSelectionEnum.THIS_MONTH:
                        criteria.push({ property: 'ThisMonth', operator: '', comparison: 'curr' });
                        break;
                    default:
                        criteria.push({ property: 'ThisMonth', operator: '', comparison: 'prev' });
                        break;
                }
                label = `Non-Billable time - ${getPeriodSelectionLabel(state.option)}`;
            } else {
                switch (state.option) {
                    case PeriodSelectionEnum.PREVIOUS_MONTH:
                        criteria.push({ property: 'FinancialYear', operator: '', comparison: 'prevMonth' });
                        break;

                    default:
                        criteria.push({ property: 'FinancialYear', operator: '', comparison: 'curr' });                        
                        break;
                }
                label = 'Non-Billable time - Year to Date';
            }
            return props.getSelectedItem(criteria, false, label, DrillDownType.timesheetSummary, 'Timesheet Lines');
        }
    };

    if (loading || currencySymbolQuery.loading) {
        return (
            <div className="rv-chart rv-chart-loading">
                {chartControllerComponent()}
                <ChartSkeleton variant="bars" />
            </div>
        );
    }

    return (
        <div className={`${classes.root} ${RV_CHART_CLASS}${isChartDataEmpty(state.hours) ? ' rv-chart--empty' : ''}`} ref={entireChartRef}>
            {chartControllerComponent()}
            <div className={classes.titleContainer}>
                <ChartHeading icon={<AccessTimeOutlinedIcon />} title="Non-Billable Time by Activity" />
                <div className="colWrapper">
                    <div className="col">
                        <div className="title">{state.leftPeriodString}</div>
                        <div className={`${classes.totalDiv} value`} onClick={() => handleTotalClick(false)}>
                            <AnimatedNumber value={state.currentTotal} format={(amount) => formatNumber(amount, 1)} /> hrs
                        </div>
                    </div>
                    <div className="col">
                        <div className="title">{state.rightPeriodString}</div>
                        <div className={`${classes.totalDiv} value`} onClick={() => handleTotalClick(true)}>
                            <AnimatedNumber value={state.currentYearTotal} format={(amount) => formatNumber(amount, 1)} /> hrs
                        </div>
                    </div>
                </div>
            </div>
            <div className={classes.barContainer} style={{ maxHeight: props.showAllRecords ? '100%' : '350px' }}>
                {props.showAllRecords && (
                    <>
                        <div className={`${classes.scrollUp} scroll`}>
                            <IconButton 
                                size="medium" 
                                onClick={onScollBar('up')}
                                ref={scrollUpAndPrevRef}
                            >
                                <KeyboardArrowUpIcon color="primary" fontSize="large" />
                            </IconButton>
                        </div>
                        <div className={`${classes.scrollDown} scroll`}>
                            <IconButton 
                                size="medium" 
                                onClick={onScollBar('down')}
                                ref={scrollDownAndNextRef}
                            >
                                <KeyboardArrowDownIcon color="primary" fontSize="large" />
                            </IconButton>
                        </div>
                    </>
                )}
                <Bar
                    ref={chartRef}
                    onContextMenu={onContextMenu}
                    // tslint:disable-next-line: no-any
                    onClick={(event: React.MouseEvent<any>) => {
                        const _data = getElementAtEvent(chartRef.current, event);
                        if (_data.length > 0 && props.getSelectedItem) {
                            const _index = getElementAtEvent(chartRef.current, event)[0].index;

                            // const item = state.months[_index];

                            const grouping = state.grouping[_index];
                            const format = state.format[_index];

                            const searchCriterias = new Array<SearchCriteria>();
                            searchCriterias.push({ property: 'Activity', operator: 'eq', comparison: grouping }, { property: 'Amount', operator: 'eq', comparison: '0' });
                            switch (state.option) {
                                case PeriodSelectionEnum.THIS_MONTH:
                                    searchCriterias.push({ property: 'ThisMonth', operator: '', comparison: 'curr' });
                                    break;
                                case PeriodSelectionEnum.PREVIOUS_MONTH:
                                    searchCriterias.push({ property: 'ThisMonth', operator: '', comparison: 'prev' });
                                    break;
                                case PeriodSelectionEnum.THIS_YEAR:
                                    searchCriterias.push({ property: 'FinancialYear', operator: '', comparison: 'curr' });
                                    break;
                                default:
                                    searchCriterias.push({ property: 'FinancialYear', operator: '', comparison: 'prev' });
                                    break;
                            }
                            props.getSelectedItem(searchCriterias, true, `Non-Billable Time by ${format}`, DrillDownType.timesheetSummary, 'Timesheet Lines');
                        }
                    }}
                    data={{
                        labels: getLabels(state.format),
                        datasets: [
                            {
                                label: 'Hours',
                                ...rvBarDatasetStyle(RV_CHART_COLORS.primary),
                                data: state.hours,
                            },
                        ],
                    }}
                    options={{
                        onHover: onHover,
                        indexAxis: 'y' as const,
                        animation: rvChartAnimation(),
                        elements: { bar: { borderWidth: 0 } },
                        responsive: true,
                        maintainAspectRatio: false,
                        scales: {
                            x: {
                                grid: rvValueAxisStyle.grid,
                                // beginAtZero: true,
                                suggestedMax: getSuggestedMaxTick(state.hours),
                                beginAtZero: true,
                                ticks: {
                                    ...rvValueAxisStyle.ticks,
                                    maxTicksLimit: getMaxTickLimit(state.hours),
                                    autoSkip: false,
                                    callback: function (this: Scale, tickValue: number, index: number, ticks: Tick[]) {
                                        return `${formatNumber(tickValue)}`;
                                    },
                                },
                            },
                            y: {
                                grid: rvCategoryAxisStyle.grid,
                                min: 0,
                                max: props.showAllRecords ? 29 : 9,
                                ticks: {
                                    ...rvCategoryAxisStyle.ticks,
                                    autoSkip: false,
                                },
                            },
                        },
                        plugins: {
                            legend: {
                                position: 'bottom' as const,
                                display: false,
                            },
                            title: {
                                display: false,
                                text: ``,
                            },
                            zoom: {
                                pan: {
                                    enabled: props.showAllRecords,
                                    onPan: onPan,
                                },
                                zoom: {
                                    wheel: {
                                        enabled: props.showAllRecords,
                                    },
                                    onZoom: onZoom,
                                },
                                // limits: {
                                //   y: { min: 0, max: 9 },
                                // },
                            },
                            tooltip: {
                                ...rvTooltipStyle,
                                callbacks: {
                                    // tslint:disable-next-line: no-any
                                    label: function (context: any) {
                                        const {
                                            //   dataIndex,
                                            //   label,
                                            formattedValue,
                                            dataset,
                                        } = context;

                                        var currentValue = convertStringNumberToNumber(formattedValue);

                                        return `${dataset.label}: ${formatNumber(currentValue, 1)}`;
                                    },
                                    // tslint:disable-next-line: no-any
                                    afterLabel: (context: any) => {
                                        const { dataIndex } = context;

                                        var timlines = state.timelines[dataIndex];
                                        return `Timelines: ${formatNumber(timlines)}`;
                                    },
                                },
                            },
                        },
                    }}
                />
                {isChartDataEmpty(state.hours) && (
                    <ChartEmptyState title="No data" hint="Nothing to show for this selection." />
                )}
            </div>
            <FormControl component="div">
                <RadioGroup name="option" value={state.option} onChange={onChangeRadio} className={classes.radioGroup}>
                    <FormControlLabel value={PeriodSelectionEnum.THIS_MONTH} control={<Radio color="primary" />} label={getPeriodSelectionLabel(PeriodSelectionEnum.THIS_MONTH)} />
                    <FormControlLabel
                        value={PeriodSelectionEnum.PREVIOUS_MONTH}
                        control={<Radio color="primary" />}
                        label={getPeriodSelectionLabel(PeriodSelectionEnum.PREVIOUS_MONTH)}
                    />
                    <FormControlLabel value={PeriodSelectionEnum.THIS_YEAR} control={<Radio color="primary" />} label={getPeriodSelectionLabel(PeriodSelectionEnum.THIS_YEAR)} />
                    <FormControlLabel
                        value={PeriodSelectionEnum.PREVIOUS_YEAR}
                        control={<Radio color="primary" />}
                        label={getPeriodSelectionLabel(PeriodSelectionEnum.PREVIOUS_YEAR)}
                    />
                </RadioGroup>
            </FormControl>
        </div>
    );
};
export interface CurrencySymbolData {
    options: Options;
}

export interface Options {
    currencySymbol: CurrencySymbol;
}

export interface CurrencySymbol {
    symbol: string;
}

export const CURRENCY_SYMBOL_QUERY = gql`
    query CurrencySymbol {
        options {
            currencySymbol {
                symbol
            }
        }
    }
`;

const NON_BILLABLE_TIMES_BY_ACTIVITY_QUERY = gql`
query NonBillableTimesByActivity($entityType: Int, $entityGuid: String, $responsibility: Int, $showAllRecords: Boolean) {
    statistics {
      time {
        nonBillableTimesByActivity (entityType: $entityType, entityGuid: $entityGuid, responsibility: $responsibility,  showAllRecords: $showAllRecords) {
          thisMonth {
            times {
              hours
              timelines
              format
              grouping
            }
            summary {
              lastPeriodTotal
              previousPeriodTotal
            }
          }
          previousMonth {
            times {
              hours
              timelines
              format
              grouping
            }
            summary {
              lastPeriodTotal
              previousPeriodTotal
            }
            financialYearToPreviousMonth {
              lastPeriodTotal
            }
          }
          thisYear {
            times {
              hours
              timelines
              format
              grouping
            }
            summary {
              lastPeriodTotal
              previousPeriodTotal
            }
          }
          previousYear {
            times {
              hours
              timelines
              format
              grouping
            }
            summary {
              lastPeriodTotal
              previousPeriodTotal
            }
          }
        }
      }
    }
  }
`;
